// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1899":"70a4828b","2255":"3b1e880a","4621":"70a4828b","4795":"70a4828b","5081":"70a4828b","6092":"70a4828b","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};